
/// <amd-module name="VSSUI/Components/DeprecatedAccordion/index" />
export * from "./Accordion";
export type { IAccordion, IAccordionItem, IAccordionProps } from "./Accordion.Props";
